import React, { Component } from 'react'
import "../App.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Switch } from "react-router-dom";
import PersonalInfo from "./PersonalInfo";
import EducationInfo from "./EducationInfo";
import IncomeInfo from "./IncomeInfo";
import FamilyInfo from "./FamilyInfo";
import ContactInfo from "./ContactInfo";
import AssetInfo from "./AssetInfo";
//import NavFormProfile from './NavFormProfile';
import UploadDoc from './UploadDoc';
import Fullbiodata from './Fullbiodata';
import PostAddress from './PostAddress';
import PAddress from './Paddress';

import Header from './Header';
//import FinalBiodata from './FinalBiodata';
import axios from "axios";
import Path from "./config";
import PaymentUpdate from './PaymentUpdate';
import FullbiodataAdmin from './FullbiodataAdmin';
import Nondani from './Nondani';
import PaymentOneTwenty from './PaymentOneTwenty';
import PhotoSample from './PhotoSample';
import PaymentSuccessonetwenty from './PaymentSuccessonetwenty';
import { PaymentSuccesseventwenty } from './PaymentSuccesseventwenty';
export class FormProfile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            phoneId: null,
            userId: null,
            sbg_first_name: "",
            isPending: false,
            bookstatus: '',
            suchi_curier_fee: '',
            suchi_fee_status: '',
            suchi_nondani_fee: '',
            suchi_suchi_fee: '',
            suchi_suchifee_status: '',

        }
    }

    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId")
        })
        this.setState({
            phoneId: localStorage.getItem("phoneId"),
            bookstatus: localStorage.getItem("bookstatus")
        })
        axios.get(Path + 'suchi_fee_manage_view.php')
            .then(function (response) {
                this.setState({
                    suchi_curier_fee: response.data.suchi_curier_fee,
                    suchi_fee_status: response.data.suchi_fee_status,
                    suchi_nondani_fee: response.data.suchi_nondani_fee,
                    suchi_suchi_fee: response.data.suchi_suchi_fee,
                    suchi_suchifee_status: response.data.suchi_suchifee_status,
                    amount: response.data.suchi_nondani_fee
                })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })

        axios.get(Path + 'Suchi_bride_groom_show_status.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                // handle success
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                //   data=response.data;
                response = response.data;
                if (response.sbg_admin_approved_status === "0") {
                    this.setState({
                        isPending: true,

                    })
                }

            }.bind(this))


    }
    bookNowHandler = () => {
        this.props.history.push(`/FormProfile/PostAddress`);
    }
    //console.log("okkkkkkkkkkkk",props);

    render() {


        return (
            <>

                <Header parentProps={this.props} />
                {this.state.suchi_fee_status === '1' ?
                    (this.state.bookstatus === '0' ?
                        <div className="container justify-content-md-center mt-4 text-danger">
                            <span className="blinking" > आपल्याला सूची ऍडव्हान्स बुक करायची असल्यास किंवा कुरियर ने मागवायची असल्यास येथे क्लिक करावे</span>
                            <button className='btn btn-success ml-3' onClick={() => this.bookNowHandler()}>Book Here</button>
                        </div>
                        : '')
                    : ''}
                { }
                <div className="container justify-content-md-center my-4  " data-bs-spy="scroll" data-bs-target="#navbar-example">
                    <div className="bg-light">

                        {this.state.isPending ?

                            <div className="border  border-5 border-primary " >
                                <Switch>
                                    {/* <Route path="/FormProfile/PersonalInfo" component={PersonalInfo} exact/> */}
                                    <Route path={`/FormProfile`} component={PersonalInfo} exact />
                                    <Route path={`/FormProfile/EducationInfo`} component={EducationInfo} exact />
                                    <Route path={`/FormProfile/IncomeInfo`} component={IncomeInfo} exact />
                                    <Route path={`/FormProfile/FamilyInfo`} component={FamilyInfo} exact />
                                    <Route path={`/FormProfile/ContactInfo`} component={ContactInfo} exact />
                                    <Route path={`/FormProfile/AssetInfo`} component={AssetInfo} exact />
                                    <Route path={`/FormProfile/UploadDoc`} component={UploadDoc} exact />
                                    <Route path={`/FormProfile/Fullbiodata`} component={Fullbiodata} exact />
                                    <Route path={`/FormProfile/PostAddress`} component={PostAddress} exact />
                                    <Route path={`/FormProfile/PAddress`} component={PAddress} exact />
                                    <Route path={`/FormProfile/Nondani`} component={Nondani} exact />
                                    <Route path={`/FormProfile/PaymentUpdate`} component={PaymentUpdate} exact />
                                    <Route path={`/FormProfile/FullbiodataAdmin`} component={FullbiodataAdmin} exact />
                                    <Route path={`/FormProfile/PaymentOneTwenty`} component={PaymentOneTwenty} exact />
                                    <Route path={`/FormProfile/PhotoSample`} component={PhotoSample} exact />
                                    <Route path={`/FormProfile/PaymentSuccesseventwenty`} component={PaymentSuccesseventwenty} exact />
                                    <Route path={`/FormProfile/PaymentSuccessonetwenty`} component={PaymentSuccessonetwenty} exact />
                                </Switch>
                            </div>
                            :
                            <Fullbiodata />

                        }
                    </div>

                </div>

            </>
        )
    }
}

export default FormProfile
